var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"fixed"},[_c('root-header')],1),_c('div',{staticClass:"main"},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),_c('root-footer'),_c('root-tabbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }